import { createApiSelectors } from 'reacticoon/selector'
import { formatUserMe } from 'modules/userMe/format'

export const registerSelectors = createApiSelectors('App::RegisterModule', formatUserMe)
